module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
    attrs: {
      "title": "Escolaridades"
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "el-card__save_form box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Dados das Escolaridades")])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "20%"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSend($event)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.form.name.$error
    },
    attrs: {
      "label": "Nome"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        _vm.$v.form.name.$touch()
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.form.description.$error
    },
    attrs: {
      "label": "Descrição"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        _vm.$v.form.description.$touch()
      }
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.form.order.$error
    },
    attrs: {
      "label": "Ordem"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "10000",
      "step": "1",
      "pattern": "[0-9]"
    },
    on: {
      "input": function($event) {
        _vm.$v.form.order.$touch()
      }
    },
    model: {
      value: (_vm.form.order),
      callback: function($$v) {
        _vm.$set(_vm.form, "order", $$v)
      },
      expression: "form.order"
    }
  }), _vm._v(" "), (_vm.$v.form.order.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
    attrs: {
      "event-click": _vm.onSend,
      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
      "is-submitted": _vm.isSubmitted
    }
  }), _vm._v(" "), _c('form-cancel-button', {
    attrs: {
      "route-name": "literacy.index"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20eb2838!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/literacy/components/Form.vue
// module id = 727
// module chunks = 2